import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import './callDuration.scss';

const ResetTimeDuration = forwardRef(({ participants }, ref) => {
    const [startTime, setStartTime] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const timerUpdateRef = useRef(null);

    const calculateTime = () => {
        if (startTime) {
            const now = new Date();
            const difference = now - startTime;
            setElapsedTime(Math.floor(difference / 1000)); // convert milliseconds to seconds
        }
    };

    useEffect(() => {
        if (isRunning) {
            timerUpdateRef.current = setInterval(() => {
                calculateTime();
            }, 1000);
        } else {
            clearInterval(timerUpdateRef.current);
        }

        return () => clearInterval(timerUpdateRef.current);
    }, [isRunning, startTime]);

    useEffect(() => {
        setIsRunning(participants.length > 0);
        if (participants.length > 0) {
            const now = new Date();
            setStartTime(now);
        } 
    }, [participants]);

    useEffect(() => {
        // Adjust the timer on visibility change
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && isRunning) {
                calculateTime();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [isRunning]);

    useEffect(() => {
        // Store the total seconds to simplify.
        localStorage.setItem('timeUsedInSecondsReset', elapsedTime);
    }, [elapsedTime]);

    const resetTimer = () => {
        setElapsedTime(0);
        setStartTime(new Date());
    };

    useImperativeHandle(ref, () => ({
        resetTimer
    }));

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
       <></>
    );
});

export default React.memo(ResetTimeDuration);
